var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-settings-detail',{attrs:{"title":_vm.title,"menu":_vm.menu,"default-active-menu":_vm.defaultMenu},on:{"change":_vm.onChangeMenu}},[_c(_vm.activeMenu,{tag:"component",attrs:{"slot":"activeView"},slot:"activeView"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e04cf14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/basic/UserAndAuthManagement/index.vue
// module id = null
// module chunks = 